import Arbor from '../../arbor'
import { ActivePage } from '../../enums/ActivePage'
import WebForm from './index'
import State from './State'

const Component = {
    currentOffset: null,
    audio: null,
    seenTCPAId: null,
    recordTCPA: false,
    phoneNumber: null,

    setProps(currentOffset, audio, seenTCPAId, recordTCPA) {

        this.currentOffset = currentOffset
        this.audio = audio
        this.seenTCPAId = seenTCPAId
        this.recordTCPA = recordTCPA

    },

    async submitForm() {

        const data = { ...State.formData, offset: this.currentOffset }

        if (this.recordTCPA && this.seenTCPAId !== null) {
            data.seenTCPAId = this.seenTCPAId
        }

        await WebForm.controller.submitAnswer(
            this.currentOffset,
            data,
        )

    },

    async submitFlexibleForm() {
        await WebForm.controller.submitFlexibleAnswer({ ...State.formData })
    },

    async advanceFlexiblePage() {
        await WebForm.controller.advanceFlexiblePage()
    },

    async submitLandingForm() {
        await WebForm.controller.submitLandingPage({ ...State.formData })
    },

    async submitPageForm() {

        const store = Arbor.store('qv')

        if (State.usesFlexibleJourney && store.navigation.activePage !== ActivePage.Landing) {

            await this.submitFlexibleForm()

            return

        }

        await this.submitLandingForm()

    },

    setFormData(key, value) {
        State.formData[ key ] = value
    },

    setFlexibleFormData(offset, key, value) {

        if (!State.formData[ offset ]) {
            State.formData[ offset ] = {}
        }

        State.formData[ offset ][ key ] = value

    },

    setFieldFormData(fieldName, value, offset = null) {

        if (offset) {

            this.setFlexibleFormData(offset, fieldName, value)

            return

        }

        this.setFormData(fieldName, value)

    },

    setFlowBoundValue(fieldName, value, offset = null) {

        this.setFlowBoundValues({
            [ fieldName ]: value,
        }, offset)

    },

    setFlowBoundValues(values, offset = null) {

        for (const [ key, value ] of Object.entries(values || {})) {

            if (!key?.length) {
                continue
            }

            if (offset) {

                this.setFlexibleFormData(offset, key, value)

                continue

            }

            this.setFormData(key, value)

        }

    },

    maybeSubmitCurrentStep(offset = null) {

        if (offset) {
            return
        }

        this.submitForm()

    },

    hasFlexibleFormData() {

        return Object.values(State.formData).some(value => (
            value !== null
            && typeof value === 'object'
            && Array.isArray(value) === false
            && Object.keys(value).length > 0
        ))

    },

    init() {

        this.$store.playWebFormAudio(this.audio, this.currentOffset)
        this.phoneNumber = this.$store.ringba.getPhoneNumber()

    },

}

export default Component
